import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import logo from '@/assets/logo-with-fullname.svg';
import { Head } from '@/components/Head';
import storage from '@/utils/storage';
import { Spinner } from '@primer/react';
import { useAuth } from '@/lib/auth';
import { useGetUserStatus } from '@/features/auth';
import { useGetFlowscaleUser } from '@/features/users';
import { ArrowSquareOut } from 'phosphor-react';

export const Landing = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const { data: userDetails } = useGetFlowscaleUser();
  const {
    data: userStatus,
    isLoading: statusLoading,
    error: statusError,
  } = useGetUserStatus(user?.username ? user?.username : userDetails?.login || '', {
    enabled: !!user,
  });

  const token = storage.getToken();
  const team = storage.getTeam();
  const isMigrating = storage.getMigrationStatus() !== 'migrate' || !storage.getMigrationStatus();
  const isNotOnboarded = storage.getOnboardingState() === 'incomplete';

  // Handle redirect when userStatus is loaded
  useEffect(() => {
    if (userStatus && userStatus?.data && token && team?.status && team?.plan) {
      // console.log('[DEBUG] STATUS:', userStatus?.data?.status, team);
      if (
        userStatus?.data?.status === 'active' &&
        team?.status === 'active' &&
        team?.plan !== 'free' &&
        isMigrating &&
        !isNotOnboarded
      ) {
        navigate('/app/projects');
      } else if (isNotOnboarded) {
        // navigate('/auth/onboarding');
        navigate('/waitlist');
      } else {
        // navigate('/auth/migration');
        navigate('/waitlist');
      }
    }
  }, [userStatus, team, navigate, isMigrating, isNotOnboarded]);

  const handleStart = () => {
    if (token && isMigrating) {
      navigate('/app/projects');
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <>
      <Head description="Welcome to bulletproof react" />
      <div className="bg-[#16191D] h-[100vh] flex items-center relative">
        {/* <div className="absolute top-0 z-50 w-full bg-gradient-to-r from-violet-400 to-blue-500 text-white text-sm">
          <div className="max-w-7xl mx-auto px-4 py-2 text-center">
            Looking to sign up?{' '}
            <a
              href={'https://tally.so/r/wMo4DM'}
              target="_blank"
              rel="noopener noreferrer"
              className="underline font-bold text-white hover:text-blue-100"
            >
              Request access
              <ArrowSquareOut size={16} className="inline ml-1" />
            </a>
            .
          </div>
        </div> */}
        <div className="max-w-7xl flex bg-[#121417] rounded-3xl flex-col gap-4 mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-16">
          <img src={logo} alt="react" />
          <p>Deploy your ComfyUI Workflows</p>
          <div className="mt-8 flex justify-center">
            <div className="flex rounded-3xl  bg-gradient-to-r from-[#1659da] to-[#16CFDA] p-0.5">
              <button
                onClick={handleStart}
                className="flex gap-3 items-center hover:bg-transparent bg-[#121417] text-white justify-center text-sm px-14 py-3 rounded-3xl"
              >
                {isLoggingIn ? (
                  <div className="flex gap-3 items-center">
                    <Spinner size="small" />
                    Logging in...
                  </div>
                ) : (
                  <h3>Get started</h3>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
